// photoUtils.js — place this in src/utils/photoUtils.js

export const compressImage = (file, maxWidth = 800, quality = 0.7) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL('image/jpeg', quality));
      };
      img.onerror = () => reject(new Error('Failed to load image'));
      img.src = e.target.result;
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
};

export const getBase64SizeKB = (base64) => {
  const base64Length = base64.length - (base64.indexOf(',') + 1);
  return Math.round((base64Length * 3) / 4 / 1024);
};

export const validateImageFile = (file) => {
  if (!file) return { valid: false, error: 'No file selected' };
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  if (!validTypes.includes(file.type)) {
    return { valid: false, error: 'Please select a JPG, PNG, or WebP image' };
  }
  if (file.size > 10 * 1024 * 1024) {
    return { valid: false, error: 'Image must be under 10MB' };
  }
  return { valid: true, error: '' };
};
